import React from 'react';
import { withStyles, Grid, Typography, CircularProgress, ButtonBase } from '@material-ui/core';
import DeviceEventEmitter, { EventName } from '../../control/event';
import PreviewDoubleItem from '../view/PreviewDoubleItem';
import SlideBanner from './Slidebanner';
import MRedux from '../view/MRedux';

import { withRouter } from "react-router-dom"

import { ListView, PullToRefresh } from 'antd-mobile';
import AppUtils from '../../control/apputlis';
import AppConfig from '../../control/config';
import Broadcast from './Broadcast';
import Livelist from './Livelist';
import MSectionHeader from '../view/MSectionHeader';
import MAnchor from '../view/MAnchor';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import { NewsItem } from './view';

const PAGE_SIZE = 6


class HomeList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            carouselIndex: 0,
            offset: 0,
            isRefreshing: false,
            isRequirOffset: false,
            changeIndex: 0,
            nowHostRecomm: [],
            newsList: [],
        }

        this.container = null;
    }


    componentDidMount() {
        AppUtils.YMPush('MAIN', 'HomeList');
        if (AppConfig.isiOS) {
            DeviceEventEmitter.on(EventName.HOME_REFRESH, this._onRefresh, this);
        }

        MRedux.recoverState('HOME_LIST_KEY_ALL', this.state);
        if (!this.state.data) {
            this.getTypeHostRecomm();
            this.getNewsList();
        } else {
            this.state.isRequirOffset = true;
            this.setState(this.state);
        }
    }

    componentWillUnmount() {
        if (AppConfig.isiOS) {
            DeviceEventEmitter.off(EventName.HOME_REFRESH, this._onRefresh, this);
        }
        if (this.container && this.container.listviewRef.scrollProperties.offset !== 0) {
            this.state.offset = this.container.listviewRef.scrollProperties.offset;
        }
        MRedux.saveState('HOME_LIST_KEY_ALL', this.state);
        this.setState = () => false;
    }

    getTypeHostRecomm = async () => {
        if (!AppData.TypeHostRecomm || AppData.TypeHostRecomm.length == 0) {
            let result = await Apis.getTypeRecommend();
            console.log('result======>', result);
            if (result.code == 200) {
                AppData.TypeHostRecomm = result.data;
            }
        }
        if (!AppData.recommAnchorData || AppData.recommAnchorData.length == 0) {
            let hostRecomm = await Apis.encryptionHostRecomm();
            if (hostRecomm.code == 200) {
                if (hostRecomm.data && hostRecomm.data.length > 0) {
                    AppData.recommAnchorData = hostRecomm.data;
                }
            }
        }
        let nowHostRecomm = [];
        for (let i = 0; i < AppData.recommAnchorData.length && i < 4; i++) {
            nowHostRecomm.push(AppData.recommAnchorData[i]);
        }

        console.log('AppData.TypeHostRecomm', AppData.TypeHostRecomm);

        this.setState({ data: AppData.TypeHostRecomm, nowHostRecomm: nowHostRecomm, isRefreshing: false });
    }

    getNewsList = async () => {
        let newsList = await Apis.encryptionNewsList();
        console.log('getNewsList', newsList);
        if (newsList.code == 200) {
            let list = [];
            for (let i = 0; i < newsList.data.length && i < 6; i++) {
                list.push(newsList.data[i])
            }
            this.setState({ newsList: list });
        }
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    _onClickMore = (data) => {
        this.props.history.push({ pathname: '/morerecomm/', data: data });
    }

    _onClickMoreNews = () => {
        this.props.history.push({ pathname: '/newsmore' });
    }

    _onClickChange = () => {
        let { changeIndex } = this.state;
        let hostRecomm = AppData.recommAnchorData;

        changeIndex++;
        if (changeIndex * 4 >= hostRecomm.length) {
            changeIndex = 0;
        }
        let nowHostRecomm = [];
        let startIdx = changeIndex * 4;
        for (let i = startIdx; i < hostRecomm.length && i < startIdx + 4; i++) {
            nowHostRecomm.push(hostRecomm[i]);
        }
        this.setState({ nowHostRecomm: nowHostRecomm, changeIndex: changeIndex });
    }

    _onRefresh = (e) => {
        console.log('_onRefresh', this.state.isRefreshing);
        if (!this.state.isRefreshing) {
            AppData.recommAnchorData = [];
            AppData.TypeHostRecomm = [];
            this.setState({ isRefreshing: true });
            this.getTypeHostRecomm();
            this.getNewsList();
        }
    }

    _handelRef = (node) => {
        this.container = node;
        if (node && this.state.isRequirOffset) node.scrollTo(0, this.state.offset);
    }

    _onEndReached = () => {

    }

    _renderItem = (rowData, sectionID, rowID) => {
        const { classes } = this.props;
        let datas = AppUtils.processList(rowData.list, 2);
        console.log('_renderItem', rowData);
        return (
            <Grid>
                {
                    rowData.list.length > 0 && this._renderSectionHeader(rowData)
                }
                {
                    datas.map((item, i) => (
                        <Grid key={i} container className={classes.doubleItemRow} direction='row'>
                            <Grid className={classes.doubleItemCon1}>
                                {
                                    item[0] && <PreviewDoubleItem hot={i == 0} data={item[0]} isRocomm={i < 2 && item[0].room_id && item[0].room_id > 0} />
                                }
                            </Grid>
                            <Grid className={classes.doubleItemCon2}>
                                {
                                    item[1] && <PreviewDoubleItem data={item[1]} isRocomm={i < 2 && item[1].room_id && item[1].room_id > 0} />
                                }
                            </Grid>
                        </Grid>
                    ))
                }
            </Grid>

        )
    }

    _renderNews = () => {
        const { newsList } = this.state;
        return (
            <Grid>
                <MSectionHeader title={'新闻'} subtitle='查看更多' chevron={true} onClick={() => this._onClickMoreNews()} />
                <Grid container justify='flex-start' direction='row' alignItems='center' style={{ width: '100vw' }}>
                    {
                        newsList.map((item, n) => (
                            <Grid key={n} container alignItems='center' style={{ maxWidth: '50vw', paddingLeft: 8, marginBottom: 16 }}>
                                <NewsItem data={item}></NewsItem>
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>

        );
    }

    _renderFooter = () => {
        const { classes } = this.props;
        const { nowHostRecomm } = this.state;
        return (<Grid container justify='center' alignItems='center' className={classes.footer}>
            <MSectionHeader title={'产品介绍'} /* subtitle='更多' chevron={true} onClick={() => window.location.href = 'http://kh.sh1057.cn'}  */ />
            <Grid container direction='column' style={{ paddingLeft: 8, paddingRight: 8, marginBottom: 48 }}>
                <Typography style={{ fontSize: 9, textAlign: 'center', color: '#0d0d0d', marginTop: 8 }}>播球帝直播是集足球、篮球等赛事于一体的体育直播APP， 提供全球足球、篮球赛事的视频直播、比分直播、动画直播、主播直播。功能特色：、1.全球赛事直播：覆盖全球各大联赛，热门赛事英超、NBA、欧冠、CBA、西甲、中超、意甲、德甲更有高清直播；免费高清无广告直播，带您直击现场；2.专业体育主播：专业美女主播陪您一起看球聊天；大咖球友相聚聊天室互动探讨；3.海量比赛数据：历史数据、实时比赛数据、球队球员近期情报状态等看球不迷茫；</Typography>
                <Typography style={{ fontSize: 9, textAlign: 'center', color: '#0d0d0d', marginTop: 8 }}>无限靓（北京）科技有限公司为体育IP方提供立项、运营、推广、销售、执行等“全生命周期”策略服务，帮助客户实现营销战略提升和价值转化；同时以体育和传播为手段,帮助企业塑造形象，实现销售转化。</Typography>
                <Typography style={{ fontSize: 12, textAlign: 'center', color: '#0d0d0d', marginTop: 8 }}>备案号 京ICP备20031072号-1 无限靓（北京）科技有限公司</Typography>
                <Typography style={{ fontSize: 9, textAlign: 'center', color: '#0d0d0d', marginTop: 8 }}>联系电话 0376-65132842 联系邮箱：3128724678@qq.com</Typography>
                <Typography style={{ fontSize: 9, textAlign: 'center', color: '#0d0d0d', marginTop: 8 }}>地址： 北京市平谷区兴谷经济开发区6区305-213084</Typography>
                <Typography style={{ fontSize: 9, textAlign: 'center', color: '#0d0d0d', marginTop: 32 }}>开发者名称:  无限靓（北京）科技有限公司 </Typography>
                <Typography style={{ fontSize: 9, textAlign: 'center', color: '#0d0d0d', marginTop: 8 }}>版本号:V1.0,
                    <a onClick={() => this.props.history.push({ pathname: '/privacystatement' })} style={{ marginLeft: 8, textDecoration: 'underline' }}>隐私协议</a>
                    <a onClick={() => this.props.history.push({ pathname: '/useragreement' })} style={{ marginLeft: 8, textDecoration: 'underline' }}>用户权限</a>
                </Typography>
            </Grid>
        </Grid>)
    }

    _renderSectionHeader = (sectionData) => {
        return (
            <MSectionHeader title={sectionData.recomm_title} subtitle='更多' chevron={true} onClick={() => this._onClickMore(sectionData)} />
        )
    }

    _renderHeader = () => {
        return (
            <Grid style={{ flexDirection: 'column', width: '100vw' }} >
                <SlideBanner history={this.props.history} />
                {/* <Broadcast /> */}
                <Livelist />
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { data, isRefreshing } = this.state;
        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        if (data) {
            return <div className={classes.list} style={{ overflowY: 'auto' }} >
                <ListView
                    initialListSize={data.length}
                    listPrefixCls='padding: 0px'
                    style={{ width: '100%', height: '100%', maxWidth: '100%', padding: 0 }}
                    contentContainerStyle={{ width: '100%', padding: 0 }}
                    dataSource={ds.cloneWithRows(data)}
                    renderRow={this._renderItem}
                    pageSize={PAGE_SIZE}
                    useBodyScroll={false}
                    renderHeader={this._renderHeader}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={10}
                    pullToRefresh={
                        <PullToRefresh
                            refreshing={isRefreshing}
                            onRefresh={this._onRefresh}
                        />
                    }
                    ref={el => { this._handelRef(el) }}
                    renderFooter={this._renderFooter}
                >
                </ListView>
            </div>
        }
        return <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <CircularProgress color='secondary' size={20} />
        </div>;

    }

}

export default withRouter(withStyles((theme) => ({
    list: {
        margin: theme.spacing(0),
        padding: theme.spacing(0),
        height: '100%',
    },
    doubleBottom: {
        width: '100%',
        margin: theme.spacing(0, 0, 3, 0),
    },
    doubleItemRow: {
        width: '100%',
        margin: theme.spacing(0, 0, 1, 0),
    },
    doubleItemCon1: {
        width: '50%',
        padding: theme.spacing(0, 0.5, 0, 1),
    },
    doubleItemCon2: {
        width: '50%',
        padding: theme.spacing(0, 1, 0, 0.5),
    },
    subtitle: {
        width: '100%',
        padding: theme.spacing(0, 1),
        margin: theme.spacing(2, 0, 2, 0),
        height: theme.typography.pxToRem(18),
    },
    subtitleFlag: {
        width: 5,
        height: '90%',
        borderRadius: 3,
        backgroundColor: theme.palette.secondary.main,
        margin: theme.spacing(0, 1, 0, 0),
    },
    bannerImg: {
        width: "calc(100vw - 16px)",
        height: '100%',
        objectFit: 'scale-down',
        borderRadius: 10,
    },
    footer: {
        width: '100%',
        marginBottom: 40,
    },
    changeBtn: {
        backgroundColor: '#FFE0E6',
        width: '45vw',
        height: 36,
        borderRadius: 18,
        color: "#F82A5C",
        fontSize: 12,
    },
}))(HomeList));